import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IMismatchPackageFolderList } from "../transfer-items.component";
import { BreadcrumbDataService } from "../../../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service";
import { IBreadcrumbItem } from "../../../../main/layout/tool-bar/model/breadcrumb.model";
import { tap } from "rxjs";
import { ComponentConstants } from "../../constants/component-constants";
import { IBucketItem } from "../../models/bucket-item.model";
import { DataService } from "../../service/data.service";
import { MatButton } from "@angular/material/button";
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";

@Component({
    selector: "app-date-mismatch-table-dialog",
    templateUrl: "./date-mismatch-table-dialog.component.html",
    styleUrls: ["./date-mismatch-table-dialog.component.scss"],
    imports: [MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class DateMismatchTableDialogComponent implements OnInit {
  private readonly dataService = inject(DataService);
  private readonly breadcrumbDataService = inject(BreadcrumbDataService);
  dialogRef = inject<MatDialogRef<DateMismatchTableDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  public dataSource: Partial<IMismatchPackageFolderList>[] = [];
  public currentBreadcrumbItem: IBreadcrumbItem = null;
  public sourceBucket: string;
  public destinationBucket: string;
  public bucketItemsList: Partial<IBucketItem>[] = [];
  displayedColumns: string[];
  constructor() {
    this.breadcrumbDataService.selectedBreadcrumb$
      .pipe(
        tap((item: IBreadcrumbItem) => {
          this.currentBreadcrumbItem = item;
          if (this.currentBreadcrumbItem.BucketType === "StudyDataCollection") {
            this.sourceBucket = ComponentConstants.STUDYDATACOLLECTION;
            this.destinationBucket = ComponentConstants.PREARCHIVE;
          } else if (
            this.currentBreadcrumbItem.BucketType === "FacilityDataCollection"
          ) {
            this.sourceBucket = ComponentConstants.FACILITYDATACOLLECTION;
            this.destinationBucket = ComponentConstants.PREARCHIVE;
          } else if (this.currentBreadcrumbItem.BucketType === "PreArchive") {
            this.sourceBucket = ComponentConstants.PREARCHIVE;
            this.destinationBucket = ComponentConstants.FACILITYARCHIVE;
          }
          this.displayedColumns = [
            "Package folder",
            this.sourceBucket,
            this.destinationBucket,
            "Checksum",
          ];
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.dataSource = [...this.data];
    let dataIds = this.dataSource.map((data) => data.PackageFolderId);
    this.dataService
      .getDataForBucketItems()
      .subscribe((res: Partial<IBucketItem>[]) => {
        if (res) {
          this.bucketItemsList = res.filter((x) => dataIds.includes(x.Id));
        }
      });
  }

  onCloseClick(): void {
    this.dataService.setDataForCheckBox(this.bucketItemsList);
    this.dialogRef.close();
  }
}
